import React, { useMemo, useState } from "react";
import { AppPage, MimaTable, PageLoader } from "../../components";
import MimaOptionMenu from "../../components/OptionMenu";
import { AnimatePresence } from "framer-motion";
import { ViewMoreContainer } from "../../containers/SignedUpBusinessesContainer";
import moment from "moment";
import constant from "../../utils/constant";
import { invoiceStore } from "../../stores";
import { ViewTodoContainer } from "../../containers";

const FashBusinesses = ({
  options1,
  options2,
  loading,
  infoModal,
  setInfoModal,
  closeModal,
  ViewMoreModal,
  handleViewMore,
  handleApprove,
  handleListInvoices,
  isFetching,
  fashData,
  isLoading,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
  todoModal,
  handleViewTodo,
}) => {
  const [data, setData] = useState([]);
  const [tradingName, setTradingName] = useState({});

  const tableData = useMemo(() => {
    if (fashData?.status === constant.Success) {
      return fashData?.data?.businesses || [];
    }
    return [];
  }, [fashData]);

  const tableColumns = [
    {
      Header: "Full Name",
      Cell: ({ cell }) => {
        const firstname = cell.row.original.users?.[0]?.firstname;
        const lastname = cell.row.original.users?.[0]?.lastname;
        return <span>{`${firstname} ${lastname}`}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
    },
    {
      Header: "Phone Number",
      accessor: "mobile",
    },
    {
      Header: "Email Address",
      accessor: "email",
    },

    {
      Header: "Buisness Category",
      accessor: "businessCategory",
      Cell: ({ cell }) => {
        const data = cell.row.original.businessCategory?.name;
        return <span>{data}</span>;
      },
    },
    {
      Header: "Website",
      Cell: ({ cell }) => {
        const website = cell.row.original.storeFrontUrl;
        return <span>{website ? website : "No Website"}</span>;
      },
    },
    {
      Header: "Created Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        const formattedDate = moment(date).format("DD/MM/YYYY hh:mm a");
        return <span>{formattedDate}</span>;
      },
    },
    {
      Header: "Last Login Date",
      Cell: ({ cell }) => {
        const lastLoginDate = cell.row.original.users?.[0]?.lastLoginDate;
        const formattedDate =
          moment(lastLoginDate).format("DD/MM/YYYY hh:mm a");
        return <span>{formattedDate}</span>;
      },
    },
    {
      Header: "Activity Status",
      accessor: "activityStatus",
      Cell: ({ cell }) => {
        const activityStatus = cell.value;
        return (
          <span
            className={`status ${
              activityStatus === "ACTIVE"
                ? "status__green"
                : activityStatus === "INACTIVE"
                  ? "status__grey"
                  : activityStatus === "BLOCKED"
                    ? "status__red"
                    : "status__dark__yellow"
            }`}
          >
            {activityStatus}
          </span>
        );
      },
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const item = cell.row.original;
        const tradingName = cell.row.original.tradingName;
        return (
          <MimaOptionMenu
            options={status === "ACTIVE" ? options2 : options1}
            onOptionSelected={(option) => {
              setData(item);
              setTradingName(tradingName);
              invoiceStore.setBusiness(item);
              if (option.value === "Approve") {
                handleApprove();
              } else if (option.value === "View More") {
                handleViewMore();
              } else if (option.value === "List Invoices") {
                handleListInvoices();
              } else if (option.value === "View Todo Info") {
                handleViewTodo();
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Fash Businesses">
      {loading ? (
        <PageLoader title="while we load your information" />
      ) : (
        <div style={{ marginTop: "2rem" }}>
          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search"
            searchVariant="wide"
            totalItems={fashData?.data?.count}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />

          {ViewMoreModal && (
            <div className="modal">
              <AnimatePresence>
                {ViewMoreModal && (
                  <ViewMoreContainer
                    data={data}
                    infoModal={infoModal}
                    setInfoModal={setInfoModal}
                    closeModal={closeModal}
                  />
                )}
              </AnimatePresence>
            </div>
          )}
        </div>
      )}

      {todoModal && (
        <div className="modal">
          <AnimatePresence>
            {todoModal && (
              <ViewTodoContainer
                closeModal={closeModal}
                item={data}
                tradingName={tradingName}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default FashBusinesses;
